module.exports = __webpack_public_path__ + "static/media/icon-acceleration.cdd7b26d.svg";